export default function Write({ style, color = '#8FC045' }) {
  return (
    <svg
      className={style}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_2779_26635)'>
        <path
          d='M8.84019 3.73283L3.36685 9.52616C3.16019 9.74616 2.96019 10.1795 2.92019 10.4795L2.67352 12.6395C2.58685 13.4195 3.14685 13.9528 3.92019 13.8195L6.06685 13.4528C6.36685 13.3995 6.78685 13.1795 6.99352 12.9528L12.4669 7.15949C13.4135 6.15949 13.8402 5.01949 12.3669 3.62616C10.9002 2.24616 9.78685 2.73283 8.84019 3.73283Z'
          stroke={color}
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M7.92639 4.70117C8.21306 6.54117 9.70639 7.94784 11.5597 8.13451'
          stroke={color}
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_2779_26635'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
